/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PremiumScheduleAvailableForAllocationResponseDto
 */
export interface PremiumScheduleAvailableForAllocationResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PremiumScheduleAvailableForAllocationResponseDto
     */
    premiumScheduleId: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumScheduleAvailableForAllocationResponseDto
     */
    contractPinnacleReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumScheduleAvailableForAllocationResponseDto
     */
    submissionOriginalCurrency?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumScheduleAvailableForAllocationResponseDto
     */
    insuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumScheduleAvailableForAllocationResponseDto
     */
    reinsuredName?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumScheduleAvailableForAllocationResponseDto
     */
    binderName?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumScheduleAvailableForAllocationResponseDto
     */
    bookedExchangeRate?: string;
    /**
     * 
     * @type {object}
     * @memberof PremiumScheduleAvailableForAllocationResponseDto
     */
    shareOfPremiumSigned?: object;
    /**
     * 
     * @type {object}
     * @memberof PremiumScheduleAvailableForAllocationResponseDto
     */
    originalNetAmountDueBroker?: object;
    /**
     * 
     * @type {Date}
     * @memberof PremiumScheduleAvailableForAllocationResponseDto
     */
    ppwDueDate: Date;
    /**
     * 
     * @type {boolean}
     * @memberof PremiumScheduleAvailableForAllocationResponseDto
     */
    closing: boolean;
    /**
     * 
     * @type {string}
     * @memberof PremiumScheduleAvailableForAllocationResponseDto
     */
    closingReference?: string;
}

/**
 * Check if a given object implements the PremiumScheduleAvailableForAllocationResponseDto interface.
 */
export function instanceOfPremiumScheduleAvailableForAllocationResponseDto(value: object): value is PremiumScheduleAvailableForAllocationResponseDto {
    if (!('premiumScheduleId' in value) || value['premiumScheduleId'] === undefined) return false;
    if (!('ppwDueDate' in value) || value['ppwDueDate'] === undefined) return false;
    if (!('closing' in value) || value['closing'] === undefined) return false;
    return true;
}

export function PremiumScheduleAvailableForAllocationResponseDtoFromJSON(json: any): PremiumScheduleAvailableForAllocationResponseDto {
    return PremiumScheduleAvailableForAllocationResponseDtoFromJSONTyped(json, false);
}

export function PremiumScheduleAvailableForAllocationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PremiumScheduleAvailableForAllocationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'premiumScheduleId': json['premiumScheduleId'],
        'contractPinnacleReferenceNumber': json['contractPinnacleReferenceNumber'] == null ? undefined : json['contractPinnacleReferenceNumber'],
        'submissionOriginalCurrency': json['submissionOriginalCurrency'] == null ? undefined : json['submissionOriginalCurrency'],
        'insuredName': json['insuredName'] == null ? undefined : json['insuredName'],
        'reinsuredName': json['reinsuredName'] == null ? undefined : json['reinsuredName'],
        'binderName': json['binderName'] == null ? undefined : json['binderName'],
        'bookedExchangeRate': json['bookedExchangeRate'] == null ? undefined : json['bookedExchangeRate'],
        'shareOfPremiumSigned': json['shareOfPremiumSigned'] == null ? undefined : json['shareOfPremiumSigned'],
        'originalNetAmountDueBroker': json['originalNetAmountDueBroker'] == null ? undefined : json['originalNetAmountDueBroker'],
        'ppwDueDate': (new Date(json['ppwDueDate'])),
        'closing': json['closing'],
        'closingReference': json['closingReference'] == null ? undefined : json['closingReference'],
    };
}

export function PremiumScheduleAvailableForAllocationResponseDtoToJSON(json: any): PremiumScheduleAvailableForAllocationResponseDto {
    return PremiumScheduleAvailableForAllocationResponseDtoToJSONTyped(json, false);
}

export function PremiumScheduleAvailableForAllocationResponseDtoToJSONTyped(value?: PremiumScheduleAvailableForAllocationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'premiumScheduleId': value['premiumScheduleId'],
        'contractPinnacleReferenceNumber': value['contractPinnacleReferenceNumber'],
        'submissionOriginalCurrency': value['submissionOriginalCurrency'],
        'insuredName': value['insuredName'],
        'reinsuredName': value['reinsuredName'],
        'binderName': value['binderName'],
        'bookedExchangeRate': value['bookedExchangeRate'],
        'shareOfPremiumSigned': value['shareOfPremiumSigned'],
        'originalNetAmountDueBroker': value['originalNetAmountDueBroker'],
        'ppwDueDate': ((value['ppwDueDate']).toISOString()),
        'closing': value['closing'],
        'closingReference': value['closingReference'],
    };
}

